import React from "react";

import { WrapperContent } from "./styles";

import HeaderPage from "../../../patterns/subpages/header";

function MobileView({pageTitle, contentMarginTop, className, borderBottom, activeBackHistory = false, children}) {

    return (
        <>
            <HeaderPage borderBottom={borderBottom} activeBackHistory={activeBackHistory}>
                {pageTitle && pageTitle}
            </HeaderPage>
            <WrapperContent contentMarginTop={contentMarginTop || 46} className={className}>
                {children}
            </WrapperContent>
        </>
    )
}

export default MobileView;